import { render, staticRenderFns } from "./assignedShortcodes.vue?vue&type=template&id=561a8749&scoped=true&"
import script from "./assignedShortcodes.vue?vue&type=script&lang=js&"
export * from "./assignedShortcodes.vue?vue&type=script&lang=js&"
import style0 from "./assignedShortcodes.vue?vue&type=style&index=0&id=561a8749&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561a8749",
  null
  
)

export default component.exports